module.exports = __webpack_public_path__ + "static/media/arrows-grey.ec2bef2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/arrows-grey.png
// module id = 34
// module chunks = 0